import { useState, useEffect, useCallback } from 'react';
import { additionalAPI } from '../services/additional-api';

type RankOption = { value: string; label: string };

const PLAIN_FALLBACK: RankOption[] = ['S', 'A', 'B', 'C', 'D', 'E'].map(v => ({ value: v, label: v }));

const JAPANESE_FALLBACK: RankOption[] = [
  { value: 'S', label: 'S（最重要）' },
  { value: 'A', label: 'A（重要）' },
  { value: 'B', label: 'B（通常）' },
  { value: 'C', label: 'C（低）' },
  { value: 'D', label: 'D（最低）' },
];

interface UseRankOptionsOptions {
  fallbackLabels?: 'plain' | 'japanese';
}

interface UseRankOptionsResult {
  rankOptions: RankOption[];
  isLoading: boolean;
  refetch: () => Promise<void>;
}

export function useRankOptions({ fallbackLabels = 'plain' }: UseRankOptionsOptions = {}): UseRankOptionsResult {
  const [rankOptions, setRankOptions] = useState<RankOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fallback = fallbackLabels === 'japanese' ? JAPANESE_FALLBACK : PLAIN_FALLBACK;

  const fetch = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await additionalAPI.getRankList();
      if (response.success && response.data) {
        setRankOptions(response.data.map((rank: any) => ({
          value: rank.id.toString(),
          label: rank.name,
        })));
      } else {
        console.error('ランク一覧の取得に失敗:', response.message);
        setRankOptions(fallback);
      }
    } catch (error) {
      console.error('ランク一覧取得エラー:', error);
      setRankOptions(fallback);
    } finally {
      setIsLoading(false);
    }
  }, [fallback]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { rankOptions, isLoading, refetch: fetch };
}
